import { Icon, Menu } from "@blueprintjs/core";
import { MenuItem2 } from "@blueprintjs/popover2";
import React from "react";

import { BasketballActionLineType } from "../../types";
import { ActionLineProps, BlockLine, DottedLine, SolidLine, SquiggleLine } from "../action-lines";
import { ActionSvgContainer } from "./action-svg-container";
import styles from "./select-action-menu.module.scss";

const actionLineProps: ActionLineProps = {
  action: { pos: { x: 0, y: 25 }, midPoints: [], endPos: { x: 47, y: 25 }, color: "#fff" },
  strokeWidth: 2,
  animateable: false,
};

interface BasketballSelectActionMenuProps {
  handleClickAction: (action: { layerType: BasketballActionLineType }) => void;
  handleCancel?: () => void;
}

export const BasketballSelectActionMenu = ({ handleClickAction, handleCancel }: BasketballSelectActionMenuProps) => {
  return (
    <div className="bp4-dark">
      <Menu className={styles.changeActionMenu}>
        <MenuItem2
          text={
            <ActionSvgContainer label="Cut">
              <SolidLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: BasketballActionLineType.CUT })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Pass">
              <DottedLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: BasketballActionLineType.PASS })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Screen">
              <BlockLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: BasketballActionLineType.SCREEN })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Dribble">
              <SquiggleLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: BasketballActionLineType.DRIBBLE })}
        />
        {handleCancel && (
          <MenuItem2 text={<Icon role="button" icon="cross" color="#fff" size={24} />} onClick={handleCancel} />
        )}
      </Menu>
    </div>
  );
};
